import { render, staticRenderFns } from "./PlusInvertIcon.vue?vue&type=template&id=6015c988&"
import script from "./PlusInvertIcon.vue?vue&type=script&lang=js&"
export * from "./PlusInvertIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports